import { HStack } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { FormattedMessage } from 'react-intl';

import { useUpdateUserPreferencesMutation } from '@/api/user/index.ts';
import { useAppSelector } from '@/store/hooks.ts';
import { getUserPreferences } from '@/store/userPreferences/slice.ts';

const OptionAlignCurrencies = () => {
  const [updateUserPreferences] = useUpdateUserPreferencesMutation();
  const userPreferences = useAppSelector(getUserPreferences);
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const handleChange = (): void => {
    sgwtWebAnalytics?.trackEvent(
      'Header',
      'user preferences, option tab, option align currencies',
      String(!userPreferences.optionAlignCurrencies),
    );
    updateUserPreferences({ ...userPreferences, optionAlignCurrencies: !userPreferences.optionAlignCurrencies });
  };

  return (
    <div className="d-flex align-items-center justify-content-between p-3 px-4 border-bottom">
      <label htmlFor="option-align-currencies">
        <FormattedMessage id="userPreferences.label.optionAlignCurrencies" />
      </label>
      <HStack className="form-check-sm form-check-valid form-switch" data-e2e="optionAlignCurrencies">
        <input
          id="option-align-currencies"
          className="form-check-input me-8px"
          type="checkbox"
          checked={userPreferences.optionAlignCurrencies}
          onChange={handleChange}
          data-e2e={'optionAlignCurrencies-checkbox'}
        />
        <span>
          <FormattedMessage id={`switchInput.${userPreferences.optionAlignCurrencies ? 'on' : 'off'}`} />
        </span>
      </HStack>
    </div>
  );
};

export default OptionAlignCurrencies;
